/**
 * The names of the resolvers the v2 API accepts in a request's resolve parameter.
 * This is a non-exhaustive list. It only contains ones we send from ProPoint.
 * TODO: Move all the resolvers to this list instead of using strings everywhere.
 */
const ApiResolvers = Object.freeze({
    ITEM_BARCODES: 'items.barcodes',

    ORDER_DOCUMENT_NUMBERS: 'orders.documentNumbers',

    ORDER_FULFILLMENT_INSTRUCTIONS: 'orders.fulfillmentInstructions',
});

module.exports = ApiResolvers;
